import type { TFunction } from "i18next";

/** Round 19 H55 -- "From a SAMA template", not `tpl.sama.cyber_series`. */
const TEMPLATE_REGULATORS: Record<string, string> = {
  sama: "SAMA",
  osfi: "OSFI",
  dora: "DORA",
  cbuae: "CBUAE",
};

export function templateWords(t: TFunction, code: string): string {
  const regulator = TEMPLATE_REGULATORS[code.split(".")[1] ?? ""];
  return regulator
    ? t("screens.scenariosView.fromRegulatorTemplate", { regulator })
    : t("screens.scenariosView.fromTemplate");
}
